import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { TextKeys } from '../../../core/i18n/text-keys';
import { IonSearchbar, Platform } from '@ionic/angular';
import { AbsenceItemsQuery } from '../../../core/state-mangement/entities/absence-items/absence-items.query';
import { AbsenceItemsService } from '../../../core/state-mangement/entities/absence-items/absence-items.service';
import { Location } from '@angular/common';
import { AbsenceItemsStore } from '../../../core/state-mangement/entities/absence-items/absence-items.store';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { TableColumn } from '../../../core/models/table-column';
import { SettingsQuery } from '../../../core/state-mangement/settings/settings.query';
import { AbsenceListItem } from 'src/app/core/models/client-models';

@Component({
  selector: 'app-absence-modal',
  templateUrl: './absence-selection-list.component.html',
  styleUrls: ['./absence-selection-list.component.scss'],
})
export class AbsenceSelectionListComponent implements OnInit, OnDestroy {
  @Input() modalView: boolean;
  @Input() title: string;
  @Output() absenceSelected = new EventEmitter<AbsenceListItem>();
  @Output() cancelEvent = new EventEmitter();
  @ViewChild('searchInput', { static: false }) searchInput: IonSearchbar;

  generalCancel = TextKeys.general.cancel;

  absences$ = new BehaviorSubject<AbsenceListItem[]>(
    this.absenceItemsQuery.getAll()
  );
  displayedColumns: string[] = ['absenceNr', 'name'];
  selectedIndexAbsence: BehaviorSubject<number> = new BehaviorSubject<number>(
    0
  );

  tableColumns$: Observable<TableColumn[]>;

  lastPage$: Observable<boolean>;
  showTable$: Observable<boolean> = this.platform.resize.pipe(
    startWith(
      this.platform.width() > this.settingsQuery.getValue()?.smallScreenWidth
    ),
    map(
      () =>
        this.platform.width() > this.settingsQuery.getValue()?.smallScreenWidth
    )
  );

  private subscriptions = new Subscription();

  constructor(
    private absenceItemsService: AbsenceItemsService,
    private absenceItemsQuery: AbsenceItemsQuery,
    private absenceItemsStore: AbsenceItemsStore,
    private location: Location,
    private translateService: TranslateService,
    private cd: ChangeDetectorRef,
    private router: Router,
    private platform: Platform,
    private settingsQuery: SettingsQuery
  ) {}

  ngOnInit() {
    this.absenceItemsService.loadAbsences();
    const columns = [];

    this.subscriptions.add(
      this.absenceItemsQuery.selectAll().subscribe((value) => {
        this.absences$.next(value);
      })
    );

    this.displayedColumns.forEach((col) => {
      const column = {
        name: col,
        selected: true,
      } as TableColumn;
      if (col == 'absenceNr') {
        column.text = TextKeys.absence.konto;
      } else {
        column.text = TextKeys.general.name;
      }
      columns.push(column);
    });
    this.tableColumns$ = new BehaviorSubject<TableColumn[]>(columns);

    if (!this.modalView) {
      this.title = this.translateService.instant(TextKeys.absence.select);
    } else {
      // we have to force change detection in modal view.
      this.cd.detectChanges();
    }

    setTimeout(() => this.searchInput.setFocus(), 500);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    if (this.modalView) {
      this.absenceItemsService.clearCache();
    }
  }

  onHover(index: number) {
    this.selectedIndexAbsence.next(index);
  }

  selected(absence: AbsenceListItem) {
    if (this.modalView) {
      this.absenceSelected.emit(absence);
    } else {
      this.absenceItemsStore.setActive(absence.id);
      // Because in badge page we come
      // from order selection so only to go
      // back is not enough to be back in badge page.
      if (this.router.url.includes('badge')) {
        this.router.navigate(['/badge']);
      } else {
        this.location.back();
      }
    }
  }

  filterAbsences(event) {
    const absences = this.absenceItemsQuery
      .getAll()
      .filter(
        (absence) =>
          absence.absenceNr
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          absence.name.toLowerCase().includes(event.target.value.toLowerCase())
      );
    this.absences$.next(absences);
    this.selectedIndexAbsence.next(0);
  }

  emitCancelEvent() {
    if (this.modalView) {
      this.cancelEvent.emit();
    } else {
      this.location.back();
    }
  }

  /**
   * On enter behave as if a row was clicked.
   */
  onEnter() {
    const absence =
      this.absenceItemsQuery.getAll()[this.selectedIndexAbsence.getValue()];
    if (absence) {
      this.selected(absence);
    }
  }
}
